/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
import { displayScreen } from 'redux/actions/screen_status';
import { setTotalFrameCount } from 'redux/actions/content_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import FetchingQuestionsScreen from 'components/screens/fetchingquestions/fetchingquestions';



/* ========== ~~~~~~~~~~ FETCHING QUESTIONS SCREEN: PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, settings, embedStatus, queueStatus }, { contentId }) => ({
    currentContentStatus: contentStatus[contentId],
    currentContentSettings: settings.contentSettings[contentId],
    inView: embedStatus.inView,
    embedSettings: settings.embedSettings,
    settings: settings
});

// map actions
const mapDispatchToProps = dispatch => ({
    setTotalFrameCount: (contentId, totalFrameCount) => dispatch(setTotalFrameCount(contentId, totalFrameCount)),
    displayScreen: (screen) => dispatch(displayScreen(screen))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FetchingQuestionsScreen);
